export default {
  endpoint_base: "https://deltaxtechnologyllc.ue.r.appspot.com/",
  stripe_key:
    "pk_live_51NCPnQHNH7igYJDl1hrP1wXIR39IWGryqVLNPmF74rqTqxvTAdc3aW7wxbzFUandy1OIsNNWDAkyvGQYQOtqMjU700zLtQiAKr",
};
